import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { firestore } from 'firebase';
import { Redirect } from 'react-router-dom';
import firebase from "firebase";
import moment from 'moment';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import profilePlaceholder from '../../no-profile.jpg';

const ProfilePage = (props) => {
    const { user, users, id, auth } = props;
    const userDetailsJSX = null;

    // if(!auth.uid) return <Redirect to={ROUTES.SIGNIN} />

    if (user) {
        return ( 
            <div className="container emp-profile">
                <form method="post">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="profile-img" >
                                <img src={user.avatarURL ? user.avatarURL : profilePlaceholder} alt="" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="profile-head">
                                        <h5>
                                            {user.companyName}
                                        </h5>
                                        <h6>
                                            {user.companyDescription}
                                        </h6>
                                        <br />
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">About</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Contact</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="profile-work">
                                <p>SOCIAL MEDIA</p>
                                {user.website && <div><a href={user.website} target="_blank" rel="noopener noreferrer"><i className="fa fa-dribbble social-media-buttons"></i>Website</a></div>}
                                {user.twitter && <div><a href={user.twitter} target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter social-media-buttons"></i>Twitter</a></div>}
                                {user.linkedin && <div><a href={user.linkedin} target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin social-media-buttons"></i>LinkedIn</a></div>}
                                {user.facebook && <div><a href={user.facebook} target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook social-media-buttons"></i>Facebook</a></div>}
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="tab-content profile-tab" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Owner</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.ceoNAME}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Number of employees</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.noOfEmpl}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Email</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.email}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Telephone</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{user.phone}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>           
            </div>
        )
    } else {
        return (
            <div className="container center">
                <p>Loading user...</p>
            </div>
        )
    }
};

const mapStateToProps = (state, ownProps) => {
    console.log(state);

    const id = ownProps.match.params.id;
    const users = state.firestore.data.users;
    const user = users ? users[id] : null;
    
    return {
        user: user,
        auth: state.firebase.auth,
        id: id,
        users: users
    }
}


export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'users'}
    ])
)(ProfilePage);
